import clsx from "clsx";

import { AssetType } from "@interfaces/index";
import {
  SteeringWheelSvg,
  BuildingCommunitySvg,
  BoxSvg,
} from "@components/index";

export const AssetItem = ({
  type,
  size = "small",
  name,
  isDisposed = false,
  justTypeName = false,
  justTypeIcon = false,
  isDefault = false,
}: {
  type: AssetType;
  size?: "small" | "big";
  name?: string;
  isDisposed?: boolean;
  justTypeName?: boolean;
  justTypeIcon?: boolean;
  isDefault?: boolean;
}) => {
  let sizeStylesContainer, sizeStylesIcon;
  switch (size) {
    case "big":
      sizeStylesContainer = "gap-x-3 md:text-600";
      sizeStylesIcon = "md:w-10 md:h-10 *:size-full";
      break;
    case "small":
    default:
      sizeStylesContainer = "gap-x-2";
      sizeStylesIcon = "text-black-54";
  }

  return justTypeName ? (
    <>
      {type === "vehicle" && "Vehicle"}
      {type === "rental_property" && "Rental Property"}
      {type === "other" && "Other"}
    </>
  ) : justTypeIcon ? (
    <>
      {type === "vehicle" && <SteeringWheelSvg />}
      {type === "rental_property" && <BuildingCommunitySvg />}
      {type === "other" && <BoxSvg />}
    </>
  ) : (
    <div
      className={clsx(
        "flex items-center text-300 font-bold text-black-100",
        sizeStylesContainer,
      )}
    >
      <div className={clsx("shrink-0", sizeStylesIcon)}>
        {type === "vehicle" && <SteeringWheelSvg />}
        {type === "rental_property" && <BuildingCommunitySvg />}
        {type === "other" && <BoxSvg />}
      </div>
      {name ? (
        <div className="max-w-64 truncate md:max-w-52">
          {name}
          {isDisposed && (
            <span className="font-normal text-black-54"> • Disposed</span>
          )}
          {isDefault && (
            <span className="font-bold text-black-54"> • Default</span>
          )}
        </div>
      ) : (
        <div>
          {type === "vehicle" && "Vehicle"}
          {type === "rental_property" && "Rental Property"}
          {type === "other" && "Other"}
        </div>
      )}
    </div>
  );
};
